
import { defineComponent } from "vue";

export default defineComponent({
  name: "Introduction",
  methods: {
    scroll(id: string) {
      this.$emit('scroll', id)
    }
  }
});
